/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseControl from './BaseControl.vue';

/**
 * Base component to wrap radio inputs with a common markup.
 *
 * It has all `BaseControl` options plus:
 *
 * @vue-prop {Object[]} options the radio buttons options
 * @vue-prop {String} options.value the radio button value
 * @vue-prop {String} options.label the radio button label
 * @vue-prop {Boolean} inline order radio buttons horizontally
 *
 * @example
 *
 * radio-buttons(
 *      v-model="form.visibility"
 *      v-validate="'required'"
 *      name="visibility"
 *      :errs="$errors"
 *      :focused="focus == 'organization'"
 *      :disabled="!form.organization"
 *      :options="options"
 * )
 *
 * @category ui.components.form-elements
 * @exports Radiobuttons
 * @component
 */
const __vue_script__ = {
    name: 'RadioButtons',

    extends: BaseControl,

    props: {
        options: {
            type: Array,
            required: true
        },
        inline: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            ready: false
        };
    },

    methods: {
        getOptionLabel(label) {
            return this.$i18n.te(label) ? this.$i18n.t(label) : label;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      key: _vm.name + "-" + _vm.uid,
      attrs: {
        label: _vm.label,
        tip: _vm.tip,
        hint: _vm.hint,
        errors: _vm.errors,
        uid: _vm.uid,
        "hint-after-label": true,
        warning: _vm.warning,
        dependant: _vm.dependant,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "radiogroup",
          class: { "radiogroup-inline": _vm.inline },
        },
        _vm._l(_vm.options, function (opt) {
          return _c(
            "label",
            {
              key: _vm.name + "-" + opt.value + "-" + Date.now(),
              staticClass: "radio",
              class: {
                "has-error": _vm.errors.length,
                "has-warning": _vm.warning,
                "with-hint": opt.hint,
              },
              attrs: { disabled: _vm.disabled },
            },
            [
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  type: "radio",
                  name: _vm.name,
                  id: opt.uid,
                  disabled: _vm.disabled || opt.disabled,
                },
                domProps: {
                  checked: _vm.value === opt.value,
                  value: opt.value,
                },
                on: { input: _vm.input },
              }),
              _c("span", { class: { "radio-label": opt.newLineHint } }, [
                _c("span", {
                  staticClass: "text",
                  domProps: {
                    innerHTML: _vm._s(_vm.getOptionLabel(opt.label)),
                  },
                }),
                opt.tip
                  ? _c("i", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.right",
                          value: opt.tip,
                          expression: "opt.tip",
                          modifiers: { right: true },
                        },
                      ],
                      staticClass: "tip icon-info-sign",
                    })
                  : _vm._e(),
                opt.newLineHint ? _c("br") : _vm._e(),
                opt.hint
                  ? _c("span", { staticClass: "hint" }, [
                      !opt.newLineHint ? _c("span", [_vm._v(" -")]) : _vm._e(),
                      _c("span", [_vm._v(" " + _vm._s(opt.hint))]),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/RadioButtons.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__